import { render, staticRenderFns } from "./major.vue?vue&type=template&id=59e150a2&scoped=true&"
import script from "./major.vue?vue&type=script&lang=js&"
export * from "./major.vue?vue&type=script&lang=js&"
import style0 from "./major.vue?vue&type=style&index=0&id=59e150a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e150a2",
  null
  
)

export default component.exports